<script setup>
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { useMessageStore } from '~/stores/messages'

// Fetch messages
const messagesStore = useMessageStore()
const { updateMessages } = messagesStore

const { data: staticKeys, suspense: messageSuspense } = useFetchMessages()

onServerPrefetch(async () => {
    await messageSuspense()
    updateMessages(staticKeys.value)
})
</script>

<template>
    <DevOnly>
        <!-- Show query devtools -->
        <VueQueryDevtools />
    </DevOnly>
    <PageMainWrapper>
        <slot />
    </PageMainWrapper>
</template>
